import { TenantConfig } from "src/tenantCustomizations/TenantCustomizations.ts";

export const DEFAULT_TENANT_CONFIG: TenantConfig = {
	erp: {
		enabled: false,
		salesEnabled: true,
		ledgerIntegrationEnabled: false,
	},
	maps: {
		enabled: false,
	},
} as const;
